module.exports = __webpack_public_path__ + "static/media/3D_image.5ce35449.png";